import { FC } from 'react';
import { IndicatorIndexedPath } from '../indicator-config-form.utils';
import { TradingFormField } from '../../trading-form-field';
import { useFormContext } from 'react-hook-form';

type MarketStructureFieldsProps = {
  path: IndicatorIndexedPath;
};

export const MarketStructureFields: FC<MarketStructureFieldsProps> = ({
  path
}) => {
  const { watch } = useFormContext();

  return (
    <>
      <TradingFormField
        type="numeric"
        name={`${path}.zigZag.deviationThreshold`}
        label="Deviation Threshold"
      />
      <TradingFormField
        type="numeric"
        name={`${path}.zigZag.depth`}
        label="Depth"
      />
    </>
  );
};
